module.exports = __webpack_public_path__ + "static/media/edit-dark.8a8f0411.svg";